module.exports = {"blog":"https://blog.trello.com","twitter":"https://www.twitter.com/trello","facebook":"https://www.facebook.com/TrelloApp","google":"https://plus.google.com/103127084407107005900/posts"}


//////////////////
// WEBPACK FOOTER
// ./resources/locales/locale-data/social/en.json
// module id = 4GGg
// module chunks = 3 4 5